var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRingfoodsLogoWht(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 214,
    height: 36,
    viewBox: "0 0 214 36",
    preserveAspectRatio: "xMidYMid meet",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "RingFoods Logo (White)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", {
    id: "desc"
  }, "Tight-bounded white logo for RingFoods: minimal padding on all sides.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    transform: "translate(0,18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(18,0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 16,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 8,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22 -6 Q 28 0 22 6",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 26 -9 Q 34 0 26 9",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    opacity: 0.95
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52,0)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 0,
    y: 2.5,
    dominantBaseline: "middle",
    fontFamily: "Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif",
    fontSize: 26,
    fontWeight: 600,
    letterSpacing: 0.2,
    textLength: 160,
    lengthAdjust: "spacingAndGlyphs",
    fill: "#fff"
  }, "RingFoods")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingfoodsLogoWht);
export default __webpack_public_path__ + "static/media/ringfoods_logo_wht.5a58beb50ffda18beb0dfb88f2e123b6.svg";
export { ForwardRef as ReactComponent };